module.exports = __webpack_public_path__ + "components/app-promo/static/en/snow-forecast__app-screenshot--4-c14e5e946779a87557c1c5024a64bb0b.jpg";